import React, { Fragment, useEffect } from 'react';
import Header from '../layout/header';
import Sidebar from '../layout/sidebar';
import Footer from '../layout/footer';
import { ToastContainer } from 'react-toastify';

import LoginError from './login-error';

import getWeb3 from '../getWeb3';

import SweetAlert from 'sweetalert2';

import { store, useGlobalState } from 'state-pool';

import CONTRACT_LIST from '../contracts/contractList';
import { useHistory } from 'react-router-dom';
import STONE_ABI from '../contracts/StoneToken.json';
import SPACESHIP_ABI from '../contracts/Spaceship.json';
import WORKER_ABI from '../contracts/Worker.json';
import CRYPTOMINES_ABI from '../contracts/CryptoMines.json';
import MARKETPLACE_ABI from '../contracts/MarketPlace.json';
import ORACLE_ABI from '../contracts/Oracle.json';

const STONE_CONTRACT = CONTRACT_LIST['STONE_CONTRACT'];
const SPACESHIP_CONTRACT = CONTRACT_LIST['SPACESHIP_CONTRACT'];
const WORKER_CONTRACT = CONTRACT_LIST['WORKER_CONTRACT'];
const CRYPTOMINES_CONTRACT = CONTRACT_LIST['CRYPTOMINES_CONTRACT'];
const MARKETPLACE_CONTRACT = CONTRACT_LIST['MARKETPLACE_CONTRACT'];
const ORACLE_CONTRACT = CONTRACT_LIST['ORACLE_CONTRACT'];

store.setState('userAddress', 'Please change to BSC Network');
store.setState('userAddressSmall', 'Please change to BSC Network');

store.setState('stoneContract', null);
store.setState('stoneAmount', 0);
store.setState('animateVideo', false);

store.setState('spaceshipContract', null);
store.setState('spaceshipAmount', 0);

store.setState('workerContract', null);
store.setState('workerAmount', 0);

store.setState('cryptominesContract', null);
store.setState('maxWorkers', 0);
store.setState('MinePower', 0);
store.setState('mintCost', 0);
store.setState('contractCost', 0);
store.setState('claimRewards', 0);
store.setState('claimTax', 0);

store.setState('cryptominesAllowance', 0);
store.setState('marketplaceAllowance', 0);

store.setState('oracleContract', null);
store.setState('marketplaceContract', null);

store.setState('Web3', null);
store.setState('loggedIn', null);

const App = ({ children }) => {
  const [web3, setWeb3] = useGlobalState('Web3');
  const [loggedIn, setLoggedIn] = useGlobalState('loggedIn');

  const [userAddress, setUserAddress] = useGlobalState('userAddress');
  const [userAddressSmall, setUserAddressSmall] = useGlobalState('userAddressSmall');

  const [stoneContract, setStoneContract] = useGlobalState('stoneContract');
  const [stoneAmount, setStoneAmount] = useGlobalState('stoneAmount');

  const [spaceshipContract, setSpaceshipContract] = useGlobalState('spaceshipContract');
  const [spaceshipAmount, setSpaceshipAmount] = useGlobalState('spaceshipAmount');

  const [workerContract, setWorkerContract] = useGlobalState('workerContract');
  const [workerAmount, setWorkerAmount] = useGlobalState('workerAmount');

  const [cryptominesContract, setCryptominesContract] = useGlobalState('cryptominesContract');
  const [maxWorkers, setMaxWorkers] = useGlobalState('maxWorkers');
  const [minePower, setMinePower] = useGlobalState('MinePower');
  const [mintCost, setMintCost] = useGlobalState('mintCost');
  const [contractCost, setContractCost] = useGlobalState('contractCost');
  const [claimRewards, setClaimRewards] = useGlobalState('claimRewards');
  const [claimTax, setClaimTax] = useGlobalState('claimTax');

  const [cryptominesAllowance, setCryptominesAllowance] = useGlobalState('cryptominesAllowance');
  const [marketplaceAllowance, setMarketplaceAllowance] = useGlobalState('marketplaceAllowance');

  const [oracleContract, setOracleContract] = useGlobalState('oracleContract');
  const [marketplaceContract, setMarketplaceContract] = useGlobalState('marketplaceContract');
  const history = useHistory();

  useEffect(() => {
    async function initializeWeb3() {
      try {
        const web3 = await getWeb3();
        const accounts = await web3.eth.getAccounts();
        const currentAccountSmall = accounts[0].slice(0, 6) + '...' + accounts[0].slice(38, 42);

        //56 = mainnet, 97 = testnet, 5777 = local
        if (window.ethereum.networkVersion == 97) {
          setLoggedIn(1);
        } else {
          setLoggedIn(0);
          return;
        }

        window.ethereum.on('accountsChanged', function (accounts) {
          history.push('/');
        });

        const stoneContract = new web3.eth.Contract(STONE_ABI, STONE_CONTRACT);
        const currentStones = await stoneContract.methods.balanceOf(accounts[0]).call({ from: accounts[0] });

        const spaceshipContract = new web3.eth.Contract(SPACESHIP_ABI, SPACESHIP_CONTRACT);
        const currentSpaceships = await spaceshipContract.methods.balanceOf(accounts[0]).call({ from: accounts[0] });

        const workerContract = new web3.eth.Contract(WORKER_ABI, WORKER_CONTRACT);
        const currentWorkers = await workerContract.methods.balanceOf(accounts[0]).call({ from: accounts[0] });

        const cryptominesContract = new web3.eth.Contract(CRYPTOMINES_ABI, CRYPTOMINES_CONTRACT);

        const currentMaxWorkers = await cryptominesContract.methods.getMaxWorkers().call({ from: accounts[0] }); //Change to Workers

        const currentMinePower = await cryptominesContract.methods.getMinePower().call({ from: accounts[0] }); //Change to Workers
        const currentClaimRewards = await cryptominesContract.methods
          .getTokenRewards(accounts[0])
          .call({ from: accounts[0] });

        const currentClaimTime = await cryptominesContract.methods.getMyTimeForClaim().call({ from: accounts[0] });

        let now = parseInt((Date.now() / 1000).toFixed(0));
        let remainingDays = (((currentClaimTime - now) / 86400) * 2).toFixed(2);
        if (remainingDays <= 0) {
          remainingDays = 0;
        }
        if (currentClaimRewards == 0) {
          remainingDays = 30;
        }
        setClaimTax(remainingDays);

        const currentMintCost = await cryptominesContract.methods.getMintCostEternal().call({ from: accounts[0] });
        const currentContractCost = await cryptominesContract.methods
          .getContractCostEternal()
          .call({ from: accounts[0] });

        const oracleContract = new web3.eth.Contract(ORACLE_ABI, ORACLE_CONTRACT);
        const marketplaceContract = new web3.eth.Contract(MARKETPLACE_ABI, MARKETPLACE_CONTRACT);

        const stoneAllowanceGame = await stoneContract.methods
          .allowance(accounts[0], CRYPTOMINES_CONTRACT)
          .call({ from: accounts[0] });

        if (stoneAllowanceGame < 1) {
          SweetAlert.fire({
            title: 'Approve Main Game Contract',
            html: 'You need to approve your <b>$ETERNAL</b> token on the <b>Main Game Contract.</b>',
            icon: 'info',
            confirmButtonText: 'Approve Contract',
            reverseButtons: true,
          }).then(async (result) => {
            await stoneContract.methods
              .approve(CRYPTOMINES_CONTRACT, web3.utils.toWei('5000000', 'ether'))
              .send({ from: accounts[0] });
          });
        }

        setWeb3(web3);
        setUserAddress(accounts[0]);
        setUserAddressSmall(currentAccountSmall);

        setStoneContract(stoneContract);
        setStoneAmount(web3.utils.fromWei(currentStones, 'ether'));

        setSpaceshipContract(spaceshipContract);
        setSpaceshipAmount(currentSpaceships);

        setWorkerContract(workerContract);
        setWorkerAmount(currentWorkers);

        setCryptominesContract(cryptominesContract);
        setMaxWorkers(currentMaxWorkers);
        setMinePower(currentMinePower);
        setMintCost(web3.utils.fromWei(currentMintCost, 'ether'));
        setContractCost(web3.utils.fromWei(currentContractCost, 'ether'));
        setClaimRewards(web3.utils.fromWei(currentClaimRewards, 'ether'));

        setOracleContract(oracleContract);
        setMarketplaceContract(marketplaceContract);
      } catch (error) {
        ////console.log(error)
      }
    }

    initializeWeb3();
  }, [
    history,
    setClaimRewards,
    setClaimTax,
    setContractCost,
    setCryptominesContract,
    setLoggedIn,
    setMarketplaceContract,
    setMaxWorkers,
    setMinePower,
    setMintCost,
    setOracleContract,
    setSpaceshipAmount,
    setSpaceshipContract,
    setStoneAmount,
    setStoneContract,
    setUserAddress,
    setUserAddressSmall,
    setWeb3,
    setWorkerAmount,
    setWorkerContract,
  ]);

  try {
    window.ethereum.on('accountsChanged', function (accounts) {
      window.location.reload();
    });

    window.ethereum.on('chainChanged', function (networkId) {
      window.location.reload();
    });
  } catch (error) {
    ////console.log(error)
  }

  console.warn = () => {};
  return (
    <Fragment>
      <div className='page-wrapper compact-wrapper' id='pageWrapper'>
        <Header />
        <div className='page-body-wrapper sidebar-icon'>
          <Sidebar />

          <div className='page-body'>{!loggedIn ? <LoginError /> : children}</div>
          <Footer />
        </div>
      </div>
      <ToastContainer />
    </Fragment>
  );
};

export default App;
